// History 모듈 매니페스트
// Core 로더가 이 객체를 읽어 라우터/스토어/네비에 주입한다.
import routes from "./routes";

export default {
  code: "HISTORY", // master_module.ExternalValue
  appCode: "HISTORY_WEB", // 권한 매핑 (Auth 서버 identity_user_application)
  name: "History",
  routes, // AppShell children 으로 주입
  store: {}, // TODO: History 도메인 스토어 이식 시 { history: store }
  // SideNav 그룹/메뉴 (7단계에서 /api/core/nav 권한 필터로 대체 예정)
  nav: {
    code: "HISTORY",
    // i18n 키 (AppSideNav 가 $t 로 렌더). support 네임스페이스 = core/i18n/locales
    name: "support.nav.title",
    menus: [
      { name: "support.nav.orders", path: "/history/orders" },
      { name: "support.nav.pastReq", path: "/history/PastReqList" },
      { name: "support.nav.supportList", path: "/history/SupportList" },
    ],
  },
  i18n: {},
};
